import React from "react";

import { IgAutocomplete, IgTextField } from "@intelligems/ig-theme";

import { mobileInputSx } from "../constants/mobileInputStyles";

interface MobileFilterAutocompleteProps {
  selectedValues?: string[] | null;
  allDataOptions: string[];
  filterKey: "customEvents" | "countryCodes" | "shippingMethods";
  placeholder?: string;
  getOptionLabel?: (option: any) => string;
  getOptionDisabled?: (option: any) => boolean;
  onChange: (
    values: string[],
    filterKey: "customEvents" | "countryCodes" | "shippingMethods"
  ) => void;
  disableCloseOnSelect?: boolean;
}

/**
 * Mobile-friendly wrapper around IgAutocomplete with 16px minimum font size
 * to prevent zoom on input focus
 */
export const MobileFilterAutocomplete = ({
  placeholder,
  selectedValues,
  allDataOptions,
  getOptionLabel,
  onChange,
  filterKey,
  disableCloseOnSelect,
  getOptionDisabled,
}: MobileFilterAutocompleteProps) => {
  return (
    <IgAutocomplete
      id={"auto-complete-analytics"}
      disableCloseOnSelect={disableCloseOnSelect ?? false}
      multiple={true}
      sx={{ minWidth: "240px" }}
      onChange={(event, value) => {
        onChange(value, filterKey);
      }}
      slotProps={{
        popper: {
          sx: { zIndex: "2000 !important" },
        },
      }}
      options={allDataOptions}
      getOptionLabel={getOptionLabel}
      getOptionDisabled={getOptionDisabled}
      value={selectedValues}
      filterSelectedOptions={true}
      renderInput={(params) => (
        <IgTextField
          {...params}
          sx={mobileInputSx}
          size={"small"}
          variant={"outlined"}
          placeholder={placeholder}
        />
      )}
    />
  );
};
